/*!
 * Copyright (c) Microsoft. All rights reserved.
 * Licensed under the MIT license. See LICENSE file in the project.
 */
import type { HashMap } from './HashMap.js'

/**
 * An alias to HashMap
 */
export type Dictionary<Value> = HashMap<Value>
